import { useCallback, useState } from 'react';

const options = {
  root: null,
  rootMargin: '50px',
  threshold: 1.0,
};

export const useInfiniteScroll = () => {
  const [isLoadMoreRefVisible, setIsLoadMoreRefVisible] = useState(false);

  const handleObserver = useCallback((entries: IntersectionObserverEntry[]) => {
    const [target] = entries;
    if (target.isIntersecting) {
      setIsLoadMoreRefVisible(true);
    } else {
      setIsLoadMoreRefVisible(false);
    }
  }, []);

  const setLoadMoreRef = useCallback(
    (loadMoreElement: Element | null) => {
      if (!loadMoreElement) return;

      const observer = new IntersectionObserver(handleObserver, options);
      observer.observe(loadMoreElement);
    },
    [handleObserver],
  );

  return { setLoadMoreRef, isLoadMoreRefVisible };
};
